import { V80_MACRO_SLOT_COUNT } from "./dakai/v80MacroCodec";
import { SDCX_MACRO_UI_SLOT_COUNT } from "./sdcx/sdcxExtraKeys";
import { ZHWX_MACRO_SLOT_COUNT } from "./zhwx/zhwxMacro";

/** 键盘快捷指令（宏）槽位：M0 = 62720 */
export const KEYBOARD_MACRO_BASE_KEYCODE = 62720;

/** 星闪等机型默认宏槽位数 */
export const DEFAULT_KEYBOARD_MACRO_SLOT_COUNT = 16;

/** Gamma75 固件仅支持 6 个宏槽（M0–M5） */
export const GAMMA75_MACRO_SLOT_COUNT = 6;

/** 星闪 DK63 / DK63 V2（keyboardType=63）：固件仅 8 个宏槽（M0–M7） */
export const XINGSHAN_DK63_MACRO_SLOT_COUNT = 8;

export type MacroSlotDeviceContext = {
  solutionRovider?: string | null;
  keyboardType?: string | null;
  vendorId?: number;
  productId?: number;
  displayname?: string | null;
};

function normalizeMacroSlotContext(
  ctx?: MacroSlotDeviceContext | string | null
): MacroSlotDeviceContext {
  if (ctx === null || ctx === undefined) return {};
  if (typeof ctx === "string") return { keyboardType: ctx };
  return ctx;
}

/** 星闪 63 配列 DK63 族（不含 SDCX dk63Machine） */
export function isXingshanDk63MacroLimitedDevice(
  ctx?: MacroSlotDeviceContext | null
): boolean {
  const c = normalizeMacroSlotContext(ctx);
  if (String(c.keyboardType ?? "") === "63") {
    const provider = String(c.solutionRovider ?? "");
    if (!provider || provider === "xingshan") return true;
  }
  return false;
}

/**
 * 当前设备在 UI / 改键 / 宏列表中可用的快捷指令槽位数（单一真相源）。
 */
export function resolveEffectiveMacroSlotCount(
  ctx?: MacroSlotDeviceContext | string | null
): number {
  const c = normalizeMacroSlotContext(ctx);
  const provider = String(c.solutionRovider ?? "");

  if (provider === "ZHWX") return ZHWX_MACRO_SLOT_COUNT;
  if (provider === "SDCX") return SDCX_MACRO_UI_SLOT_COUNT;
  if (provider === "dakai") return V80_MACRO_SLOT_COUNT;
  if (String(c.keyboardType ?? "") === "gamma75")
    return GAMMA75_MACRO_SLOT_COUNT;
  if (isXingshanDk63MacroLimitedDevice(c)) {
    return XINGSHAN_DK63_MACRO_SLOT_COUNT;
  }
  return DEFAULT_KEYBOARD_MACRO_SLOT_COUNT;
}

/** @deprecated 优先使用 resolveEffectiveMacroSlotCount；仅 keyboardType 时 DK63(63) 仍会返回 8 */
export function resolveKeyboardMacroSlotCount(
  keyboardType?: string | null
): number {
  return resolveEffectiveMacroSlotCount({ keyboardType });
}

/** UI 宏槽最大 macroId（含），如 5 槽时返回 4 */
export function resolveKeyboardMacroMaxUiId(
  ctx?: MacroSlotDeviceContext | string | null
): number {
  return Math.max(0, resolveEffectiveMacroSlotCount(ctx) - 1);
}

export function buildKeyboardMacroKeyCodes(slotCount: number): number[] {
  const safe = Math.max(0, Math.floor(slotCount));
  return Array.from(
    { length: safe },
    (_, i) => KEYBOARD_MACRO_BASE_KEYCODE + i
  );
}

export function resolveMacroKeyCodeMatrix(
  ctx?: MacroSlotDeviceContext | string | null
): number[][] {
  return [buildKeyboardMacroKeyCodes(resolveEffectiveMacroSlotCount(ctx))];
}
